import React, { useEffect, useState } from "react";
import styles from "./num-of-sync-started.module.css";
import { AdminPartialUser } from "@boxem/core-api-schema";
import Flex from "@/components/Flex/Flex";
import LoadingSpinner from "@/components/LoadingSpinner/LoadingSpinner";

type NumOfSyncStartedProps = {
  users: AdminPartialUser[];
  loading: boolean;
};

const NumOfSyncStarted = ({
  users,
  loading,
}: NumOfSyncStartedProps) => {
  const [numOfSyncStarted, setNumOfSyncStarted] = useState<number>(0);

  const generateStatData = () => {
    let startedNum = 0;

    users.map(user => {
      if (user.numOfSyncStarted === 0 && !!user.sellerId) {
        startedNum++;
      }

      startedNum += user.numOfSyncStarted;
    });

    setNumOfSyncStarted(startedNum);
  };

  useEffect(() => {
    if (!loading && !!users) generateStatData();
  }, [users, loading]);

  return (
    <Flex
      justify="center"
      align="center"
      direction="column"
      className={styles.statContainer}
    >
      {(loading) ? <LoadingSpinner size="3rem" /> : (
        <>
          <h1 className={`${styles.statHeader} strong`}>{numOfSyncStarted}</h1>
          <h3 className={`${styles.statSubHeader} strong`}>Sync's Started</h3>
        </>
      )}
    </Flex>
  );
};

export default NumOfSyncStarted;